import IntroStyle from './IntroStyle'
//import Logo from '../../images/Logo'

//About will have a header, paragraph, and 'Book us today' button
//About will have a transparent background

const Intro = ({ scrollToSection, contact }) => {
  return (
    <IntroStyle>
      <h1>New Wave Retro Games</h1>
      <p>Blending technology for the next level of gaming.</p>
      <button onClick={() => scrollToSection(contact)}>Explore</button>
    </IntroStyle>
  )
}

export default Intro
